import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Form } from "react-bootstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
    firstName: yup.string().required("First name is required").matches(/^[a-zA-Z]+$/, "Invalid name"),
    lastName: yup.string().required("Last name is required").matches(/^[a-zA-Z]+$/, "Invalid name"),
    email: yup.string().required("Email is required").email("Invalid email address"),
    mobileNumber: yup.string().required("Mobile number is required").matches(/^\d{10}$/, "Invalid phone number"),
    bio: yup.string().min(16,"Bio must be more then 15 characters").required("Bio must be required"),
    dob: yup
        .date()
        .required("Date of birth is required")
        .test("age", "You must be at least 18 years old", (value) => {
            const today = new Date();
            const birthDate = new Date(value);
            const age = today.getFullYear() - birthDate.getFullYear();
            return age >= 18;
        }),
    // userPicture: yup
    //     .mixed()
    //     .required("Profile image is required")
    //     .test("fileSize", "File too large", (value) => value && value.size <= 5 * 1024 * 1024)
    //     .test("fileType", "Unsupported file format", (value) =>
    //         ["image/jpeg", "image/png"].includes(value?.type)
    //     ),
});

const Step1 = ({ nextStep, updateFormData, formData }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: formData,
    });
    const [selectedImage, setSelectedImage] = useState(null);
    const [error, setError] = useState('');
    const walletAddress = localStorage.getItem("WalletAddress");

    const validateImage = (file) => {
        const maxFileSize = 5 * 1024 * 1024; // 5 MB
        const allowedFormats = ['image/jpeg', 'image/png'];

        if (!allowedFormats.includes(file.type)) {
            setError('Only JPG and PNG formats are allowed.');
            return false;
        }

        if (file.size > maxFileSize) {
            setError('File size must not exceed 5 MB.');
            return false;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);

        // img.onload = () => {
        //     if (img.width !== 413 || img.height !== 531) {
        //         setError('Image must be exactly 413x531 pixels (passport size).');
        //         setSelectedImage(null);
        //     } else {
        //         setError('');
        //         setSelectedImage(img.src);
        //     }
        // };

        return true;
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && validateImage(file)) {
            setSelectedImage(URL.createObjectURL(file));
            updateFormData({ userPicture: file });
        }
    };
    const submit = (data) => {
        console.log("data", data);
        
        // if (!selectedImage) {
        //     setError('Please upload a valid passport-size photo.');
        //     return;
        // }
        // Proceed to the next step
        console.log('User picture uploaded successfully!');
        // updateFormData({ ...formData, firstName: formData.firstName, lastName: formData.lastName, bio: formData.bio });
        nextStep();
    };

    const handleChange = (e) =>{
        updateFormData({...formData, [e.target.name]: e.target.value})
    }
    console.log("FormData Step 1", formData);

    return (
        <div className="container">
            <Form className="box mt-4"
             onSubmit={submit}
             >
                <Form.Group>
                    <p className="mt-3">First Name</p>
                    <Form.Control name="firstName" {...register("firstName")} onChange={(e)=>  handleChange(e)} defaultValue={formData.firstName} isInvalid={!!errors.firstName} />
                    <Form.Control.Feedback type="invalid">{errors.firstName?.message}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group>
                    <p className="mt-3">Last Name</p>
                    <Form.Control name="lastName" {...register("lastName")} onChange={(e)=>  handleChange(e)} defaultValue={formData.lastName} isInvalid={!!errors.lastName} />
                    <Form.Control.Feedback type="invalid">{errors.lastName?.message}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <p className="mt-3">User Name</p>
                    <Form.Control name="username" {...register("username")} value ={formData.username} onChange={(e)=>  handleChange(e)} defaultValue={formData.username} isInvalid={!!errors.username} />
                    <Form.Control.Feedback type="invalid">{errors.username?.message}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <p className="mt-3">Email</p>
                    <Form.Control {...register("email")} value={formData.email}
                    //  placeholder={formData.email} 
                     name="email"
                    onChange={(e)=>  handleChange(e)}
                     isInvalid={!!errors.email} />
                    <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <p className="mt-3">Wallet Address</p>
                    <Form.Control type="text" disabled={true} {...register("walletAddress")} defaultValue={formData.walletAddress} placeholder={formData.walletAddress} />
                    {/* <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback> */}
                </Form.Group>
                <Form.Group>
                    <p className="mt-3">Date of Birth</p>
                    <Form.Control  name="dob" type="date" {...register("dob")} onChange={(e)=>  handleChange(e)} isInvalid={!!errors.dob} />
                    <Form.Control.Feedback type="invalid">{errors.dob?.message}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <p className="mt-3">Bio</p>
                    <Form.Control  name="bio" as="textarea" onChange={(e)=>  handleChange(e)} {...register("bio")} placeholder={formData.bio}  rows={3} />
                    {/* <Form.Control type="date" isInvalid={!!errors.dob} /> */}
                    <Form.Control.Feedback type="invalid">{errors.bio?.message}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <p className="mt-3">User Profile</p>
                    <Form.Control
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        required
                    />
                    {/* <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback> */}

                </Form.Group>

                {error && <p className="text-danger">{error}</p>}

                {selectedImage && (
                    <div className="mt-3">
                        <p className="mt-3">Image Preview:</p>
                        <img
                            src={selectedImage}
                            alt="Selected"
                            style={{ width: '100px', height: '125px', objectFit: 'cover' }}
                        />
                    </div>
                )}
                <div className="mt-3">
                    
                </div>
            </Form>
            <Button type="submit" className="mt-2" style={{ float: "right" }} onClick={submit}>Next</Button>
        </div>
    );
};

export default Step1;
